import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Book, ChevronRight, X } from 'lucide-react';
import './style/MakeFromBook.css';

const books = [
  { id: 1, title: 'ReactNotes', filename: 'reactjs_tutorial.pdf' },
  { id: 2, title: 'Science Handbook', filename: 'science_book.pdf' },
  { id: 3, title: 'English Literature', filename: 'english_book.pdf' },
  { id: 4, title: 'History Chronicles', filename: 'history_book.pdf' },
  { id: 5, title: 'Geography Atlas', filename: 'geography_book.pdf' },
  { id: 6, title: 'Computer Science Guide', filename: 'cs_book.pdf' },
  { id: 7, title: 'Art & Design', filename: 'art_book.pdf' },
  { id: 8, title: 'Physical Education', filename: 'pe_book.pdf' },
  { id: 9, title: 'Music Theory', filename: 'music_book.pdf' },
  { id: 10, title: 'Foreign Languages', filename: 'language_book.pdf' },
];

export default function MakeFromBook() {
  const [selectedBook, setSelectedBook] = useState(null);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const navigate = useNavigate();

  const handleBookSelect = (book) => {
    setSelectedBook(book);
    if (book.title === 'ReactNotes') {
      setShowPdfPreview(true);
    } else {
      setShowPdfPreview(false);
    }
  };

  const handleNext = () => {
    if (selectedBook) {
      navigate(`/assignments/choose-from-book/${selectedBook.id}`);
    }
  };

  const closePdfPreview = () => {
    setShowPdfPreview(false);
  };

  return (
    <div className="make-from-book-container assignment-info bg-gradient-to-br from-blue-50 to-indigo-100">
      <h1>Available Books</h1>
      <p className="subtitle">Select a book to create an assignment</p>
      
      <div className="books-grid">
        {books.map((book) => (
          <div 
            key={book.id} 
            className={`book-card ${selectedBook === book ? 'selected' : ''}`}
            onClick={() => handleBookSelect(book)}
          >
            <div className="book-icon">
              <Book size={36} />
            </div>
            <h3>{book.title}</h3>
            <p>{book.filename}</p>
          </div>
        ))}
      </div>

      {showPdfPreview && (
        <div className="pdf-preview-overlay">
          <div className="pdf-preview-container">
            <button className="close-preview" onClick={closePdfPreview}>
              <X size={24} />
            </button>
            <iframe
              src={`/pdfs/reactjs_tutorial.pdf`}
              title="PDF Preview"
              width="100%"
              height="600px"
              className="pdf-iframe"
            />
          </div>
        </div>
      )}

      <div className="navigation">
        <button className="nav-button" disabled={!selectedBook} onClick={handleNext}>
          Next
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
}